import { Outlet } from "react-router-dom";
import { NavBar } from "../components/common/NavBar";

export function AppLayout() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <NavBar />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
